<img src="/assets/images/general/vespa.svg" />
<p class="soon-title">{{ 'coming_soon' | translate }}</p>
<p class="soon-sub ods-typography-body-s-bold">
  {{ 'box_is_spreading' | translate }}
</p>
